import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-month-date',
  templateUrl: './month-date.component.html',
  styleUrls: ['./month-date.component.css']
})
export class MonthDateComponent implements OnInit {

  @Input() currentMontName!: string;
  
  @Output() seeDifferentMonth: EventEmitter<any> = new EventEmitter();
  @Output() seeDifferentView:  EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  prevMonth(){
    this.seeDifferentMonth.emit('prev');
  };
  nextMonth(){
    this.seeDifferentMonth.emit('next');
  };
  // changeViewMode(){
  //   this.seeDifferentView.emit('show2');
  // }


}
